'use client';

import { IcArrowRight, Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { useBrandsProposalUnviewed } from '../../campaigns/hooks/useBrandsProposalUnviewed';
import { useMyRecruitmentUnviewed } from '../../campaigns/hooks/useMyRecruitmentUnviewed';
import { getPaths, useNavigate } from '../../common';
import { curatorQueries } from '../../query-factory';
import { BRAND_BLUE } from '../constants/colors';

interface CampaignShortcutGroupProps {
  className?: string;
}

export const CampaignShortcutGroup = ({ className }: CampaignShortcutGroupProps) => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  const paths = getPaths(service);
  const { data: mypageData } = useQuery(curatorQueries.mypage.data());

  const appliedCount = mypageData?.appliedCampaignCount ?? 0;
  const proposedCount = mypageData?.receivedProposalCount ?? 0;
  const { hasUnviewed: hasNewProposal } = useBrandsProposalUnviewed();
  const { hasUnviewed: hasNewRecruitment } = useMyRecruitmentUnviewed();

  const handleAppliedClick = () => {
    navigate(
      paths.campaignCollaboration({
        query: { category: 'SEEDING', type: 'MY_PROPOSAL', seedingStatus: 'PENDING' },
      }),
    );
  };

  const handleProposedClick = () => {
    navigate(
      paths.campaignCollaboration({
        query: { category: 'SEEDING', type: 'BRANDS_PROPOSAL', seedingStatus: 'PENDING' },
      }),
    );
  };

  return (
    <div className={className}>
      <div className="flex gap-[16px] h-[40px] items-center">
        <button
          type="button"
          className="flex-1 flex flex-col gap-[2px] items-start cursor-pointer"
          onClick={handleAppliedClick}
        >
          <div className="flex gap-[2px] items-center">
            <Typography variant="body13pxReg">내가 신청한 캠페인</Typography>
            {/* SID-4418: 숏컷 화살표 아이콘 컬러 gray-500 → black */}
            <IcArrowRight width={12} height={12} strokeColor="black" />
          </div>
          <div className="flex items-start gap-[2px]">
            <Typography variant="body14pxSemi">{appliedCount}개</Typography>
            {/* 신청한 캠페인 0개면 blue dot 미노출 — 화면 표시 개수와 직접 정합. (SID-4312) */}
            {hasNewRecruitment && appliedCount > 0 && (
              <div
                className="rounded-full size-[4px] mt-[2px]"
                style={{ backgroundColor: BRAND_BLUE }}
              />
            )}
          </div>
        </button>
        <div className="w-px h-full bg-[#ebebeb]" />
        <button
          type="button"
          className="flex-1 flex flex-col gap-[2px] items-start cursor-pointer"
          onClick={handleProposedClick}
        >
          <div className="flex gap-[2px] items-center">
            <Typography variant="body13pxReg">제안 받은 캠페인</Typography>
            {/* SID-4418: 숏컷 화살표 아이콘 컬러 gray-500 → black */}
            <IcArrowRight width={12} height={12} strokeColor="black" />
          </div>
          <div className="flex items-start gap-[2px]">
            <Typography variant="body14pxSemi">{proposedCount}개</Typography>
            {/* 제안 받은 캠페인 0개면 blue dot 미노출 — 화면 표시 개수와 직접 정합. (SID-4120 재발) */}
            {hasNewProposal && proposedCount > 0 && (
              <div
                className="rounded-full size-[4px] mt-[2px]"
                style={{ backgroundColor: BRAND_BLUE }}
              />
            )}
          </div>
        </button>
      </div>
    </div>
  );
};
